import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [frentista, setFrentista] = useState(null);
  const [masterAuth, setMasterAuth] = useState(!!localStorage.getItem("master_token"));
  // Só fica "carregando" quando há token de FRENTISTA para validar via /me.
  // Master é síncrono (localStorage) → entra direto, sem loader de autenticação extra (evita o "2 loaders").
  const [loading, setLoading] = useState(!!localStorage.getItem("frentista_token"));

  useEffect(() => {
    const ft = localStorage.getItem("frentista_token");
    if (!ft) return;
    const boot = async () => {
      try {
        const { data } = await api.get("/auth/frentista/me", {
          headers: { Authorization: `Bearer ${ft}` },
        });
        setFrentista(data);
      } catch {
        localStorage.removeItem("frentista_token");
      } finally {
        setLoading(false);
      }
    };
    boot();
  }, []);

  const loginFrentista = async (username, senha, geo = {}) => {
    const { data } = await api.post("/auth/frentista/login", { username, senha, ...geo });
    localStorage.setItem("frentista_token", data.token);
    setFrentista(data.frentista);
    return { ...data.frentista, caixa: data.caixa };
  };

  const logoutFrentista = () => {
    localStorage.removeItem("frentista_token");
    setFrentista(null);
  };

  // `usuario` (pedido de 27/10): usuário Master com nome; vazio = senha Master única.
  const loginMaster = async (senha, geo = {}, usuario = "") => {
    const corpo = usuario ? { senha, usuario, ...geo } : { senha, ...geo };
    const { data } = await api.post("/auth/master/login", corpo);
    localStorage.setItem("master_token", data.token);
    setMasterAuth(true);
  };

  const logoutMaster = () => {
    localStorage.removeItem("master_token");
    setMasterAuth(false);
  };

  return (
    <Ctx.Provider value={{ frentista, masterAuth, loading, loginFrentista, logoutFrentista, loginMaster, logoutMaster, setFrentista }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
